var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home center-content"},[(_vm.endpointData && _vm.endpointData.length > 0)?_c('fChart',{attrs:{"responseData":_vm.endpointData}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }